// Kleine lijn-iconen als SVG, gebouwd met createElementNS (geen innerHTML, geen extern bestand).
// Kleur en lijndikte komen uit CSS (.icon), zodat ze currentColor volgen.

const SVG_NS = 'http://www.w3.org/2000/svg';

type IconName = 'crib' | 'cribPlus' | 'check' | 'heart' | 'left' | 'right' | 'close';

// Wieg: een mandje met een kap, op een gebogen schommelvoet.
const CRIB = ['M3.5 11h17v.5A6.5 6.5 0 0 1 14 18h-4a6.5 6.5 0 0 1-6.5-6.5z', 'M3.5 11A8 8 0 0 1 11.5 3v8', 'M9 18l-1 2.4', 'M15 18l1 2.4', 'M4.5 20.6c4.8-1.6 10.2-1.6 15 0'];

const PATHS: Record<IconName, string[]> = {
  crib: CRIB,
  cribPlus: [...CRIB, 'M18 2.5v5', 'M15.5 5h5'],
  check: ['M5 12.5l4.5 4.5L19 7.5'],
  heart: ['M12 20s-7.2-4.4-8.9-8.8C1.9 8 3.8 4.6 7.1 4.6c2 0 3.5 1.1 4.9 2.9 1.4-1.8 2.9-2.9 4.9-2.9 3.3 0 5.2 3.4 4 6.6C19.2 15.6 12 20 12 20z'],
  left: ['M15 5l-7 7 7 7'],
  right: ['M9 5l7 7-7 7'],
  close: ['M6 6l12 12', 'M18 6L6 18'],
};

export function icon(name: IconName, cls = ''): SVGSVGElement {
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('class', `icon icon-${name}${cls ? ` ${cls}` : ''}`);
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');
  for (const d of PATHS[name]) {
    const path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', d);
    svg.appendChild(path);
  }
  return svg;
}
